import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthFacade, Helper, SharedFacade } from '@piqet-angular/data';
import {
  CustomModalService,
  emailRegex,
  OtpEventData,
  RedirectService,
} from '@piqet-angular/shared';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as jwt_decode from 'jwt-decode';
import Swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import { CommonService } from 'libs/shared/src/lib/service/common.service';
@Component({
  selector: 'piqet-angular-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('inputField', { static: false }) inputField!: ElementRef<HTMLInputElement>;
  loginForm!: FormGroup;
  submitted = false;
  isSSOLogin = false;
  userAccessURL: any;
  specialCharactersflag: boolean = true;
  upperCaseCharactersflag: boolean = true;
  lowerCaseCharactersflag: boolean = true;
  numberCharactersflag: boolean = true;
  minLengthsflag: boolean = true;
  fieldTextTypeNewPwd = false;
  fieldTextTypeConfirmPwd = false;
  fieldTextType!: boolean;
  ipAddress: any;
  typeSelected = 'line-spin-clockwise-fade';
  deviceId: string = '';

  constructor(
    private formBuilder: FormBuilder,
    public authFacade: AuthFacade,
    public sharedFacade: SharedFacade,
    public authService: AuthenticationService,
    private route: Router,
    private router: ActivatedRoute,
    private renderer: Renderer2,
    private spinnerService: NgxSpinnerService,
    private cookieService: CookieService,
    private store: Store,
    private modal: CustomModalService,
    private commonService: CommonService,
    private redirectService: RedirectService
  ) {
    Swal.close();
    this.router.queryParams.subscribe((data: any) => {
      if (data.loginType == 'loginWithAzure') {
        const tokenExpiry: any = jwt_decode.jwtDecode(data.token);
        const expiry = tokenExpiry.exp * 1000; // convert second to millisecond
        this.cookieService.set('token', data.token, new Date(expiry));
        this.cookieService.set('organizationId', data.organizationId, new Date(expiry));
        this.cookieService.set('userId', data.userId, new Date(expiry));
        this.authFacade.loginWithAzure([], data.token, data.isFlag, data.isLoggedIn);
      }
    });
    // this.authFacade.getIpAdress();
    this.router.queryParams.subscribe(params => {
      const queryValue = Object.keys(params)[0] || '';
      if (queryValue) {
        this.authService.checkOrganizationSSOLogin(queryValue).subscribe((data: any) => {
          if (data.data.isSSOEnabled) {
            this.isSSOLogin = true;
            this.userAccessURL = data.data.userAccessURL;
          }
        });
      }
    });
  }

  ngOnInit(): void {
    const reg = emailRegex;
    this.authFacade.showOtpPage(false);
    this.authFacade.clearLoginMessageError();
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email, Validators.pattern(reg)]],
      password: ['', Validators.required],
    });
    this.router.queryParams.subscribe(params => {
      const email = params['email'];
      const returnUrl = params['returnUrl'];

      if (email) {
        this.loginForm.patchValue({ username: email });
      }

      // Store return URL if provided via query parameter
      if (returnUrl) {
        if (!returnUrl.includes('project-detail-report')) {
          this.redirectService.setRedirectUrl(returnUrl);
        }
      }
    });
    this.store
      .select((state: any) => state.auth)
      .subscribe(authState => {
        if (authState.maxAttemptsReached) {
          this.showInstructionsModal();
        }
      });
  }

  showInstructionsModal() {
    this.modal.invoke('InstructionsComponent', {
      class: 'instruction-view-modal',
    });
  }

  toggleFieldOldPwd() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldNewPwd() {
    this.fieldTextTypeNewPwd = !this.fieldTextTypeNewPwd;
  }

  validationsPassword() {
    const isValidate = Helper.passwordValidatior(this.loginForm.controls['password'].value);
    this.upperCaseCharactersflag = isValidate.upperCaseCharactersflag;
    this.lowerCaseCharactersflag = isValidate.lowerCaseCharactersflag;
    this.numberCharactersflag = isValidate.numberCharactersflag;
    this.specialCharactersflag = isValidate.specialCharactersflag;
    this.minLengthsflag = isValidate.minLengthsflag;
  }
  submit(loginType?: any) {
    if (loginType === 'loginWithAzure') {
      window.location.href = this.userAccessURL;
    } else {
      this.submitted = true;
      if (this.loginForm.invalid) {
        return;
      }
      this.authFacade.clearError();
      if (!this.loginForm.valid) {
        this.loginForm.get('username')?.markAsTouched();
        this.loginForm.get('password')?.markAsTouched();
        this.submitted = false;
        return;
      }
      this.spinnerService.show();
      // Step 1: Get IP address (service handles fallback and timeout internally)
      this.authService.getIPAddress().subscribe({
        next: (ip: string | null) => {
          this.ipAddress = ip ?? null;
          this.callLogin();
        },
      });
    }
  }
  // Step 2: Call login API
  callLogin() {
    const loginPayload = {
      userName: this.loginForm.controls['username'].value,
      password: this.loginForm.controls['password'].value,
      ipAddress: this.ipAddress,
      deviceId: this.commonService.initDeviceId(),
    };
    this.authFacade.login(loginPayload);
    sessionStorage.removeItem('registerEmail');
  }

  ngAfterViewInit() {
    if (this.inputField) {
      this.renderer.selectRootElement(this.inputField.nativeElement).focus();
    }
  }

  verifyOtpMethod(payload: OtpEventData) {
    this.authFacade.verifyOtp(payload, this.ipAddress);
  }

  onLoginIssue() {
    this.showInstructionsModal();
  }
}
